import calendarSettingsStyles from "../../../styles/calendarSettings.module.css"

const RowCell = ({ children, width }: { children: React.ReactNode, width?: number | string }) => {
  return (
    <div className={calendarSettingsStyles.tableRowCell}
      style={{
        width: width,
        minWidth: width
      }}>
      {children}
    </div>
  )
}

export default RowCell